// Single-owner admin token helpers (localStorage-backed).
// localStorage can throw in private/incognito modes or when quota is exceeded;
// surface those errors to the console so they aren't silently swallowed.
const KEY = "cveAdminToken";

export function getAdminToken() {
  try {
    return localStorage.getItem(KEY) || null;
  } catch (err) {
    console.warn("adminAuth: localStorage read failed", err);
    return null;
  }
}

export function setAdminToken(token) {
  try {
    localStorage.setItem(KEY, token);
  } catch (err) {
    console.warn("adminAuth: localStorage write failed", err);
  }
}

export function clearAdminToken() {
  try {
    localStorage.removeItem(KEY);
  } catch (err) {
    console.warn("adminAuth: localStorage remove failed", err);
  }
}
